import isPreviewHost from 'shared/utils/isPreviewHost';

const SITE_KEY = import.meta.env.VITE_RECAPTCHA_CLIENT_KEY || '';
const NODE_ENV = import.meta.env.NODE_ENV || 'development';

interface WindowWithGrecaptcha extends Window {
  grecaptcha: {
    ready: (callback: () => void) => void;
    execute: (siteKey: string, options: { action: string }) => Promise<string>;
  };
}

const getReCaptchaToken = async (): Promise<string> =>
  // eslint-disable-next-line implicit-arrow-linebreak
  new Promise((resolve, reject) => {
    // Skip reCAPTCHA in test mode, when no valid key is configured (development), or on ephemeral
    // PR previews, whose host can't be registered on the site key (see isPreviewHost).
    if (NODE_ENV === 'test' || !SITE_KEY || isPreviewHost()) {
      resolve('development-skip-recaptcha');
      return;
    }
    const windowWithGrecaptcha = window as unknown as WindowWithGrecaptcha;
    windowWithGrecaptcha.grecaptcha.ready(() => {
      windowWithGrecaptcha.grecaptcha
        .execute(SITE_KEY, { action: 'submit' })
        .then((token) => {
          resolve(token);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });

export default getReCaptchaToken;
